//# sourceMappingURL=cypress.mjs.map
/// <reference types="./cypress.d.mts" />
import * as $attribute from "../../redraw_dom/redraw/dom/attribute.mjs";
import { attribute } from "../../redraw_dom/redraw/dom/attribute.mjs";

/**
 * Add a `data-cy` on an element. Used in conjunction with Cypress to put
 * unique identifiers on element to ease access.
 *
 * ```gleam
 * html.div(
 *   [cypress.data("hello-world")],
 *   [html.text("Hello World")],
 * )
 * ```
 */
export function data(content) {
  return attribute("data-cy", content);
}
